(() => {
  const host = document.querySelector('[data-vkc-host]');
  if (!host) return;

  let data;
  try {
    data = JSON.parse(host.querySelector('[data-vkc-data]').textContent);
  } catch (error) {
    console.warn('Velune Kaching configurator: invalid product data', error);
    return;
  }
  const details = document.getElementById('ProductInformation-' + host.dataset.vkcDetailsId);
  const current = data.products.find((product) => String(product.id) === String(data.currentId));
  if (!details || !current) return;

  const sizeNumber = (value) => {
    const match = String(value || '').match(/(?:EU\s*)?(3[5-9]|4[0-7])\b/i);
    return match ? match[1] : null;
  };
  const productSize = (product, eu) =>
    product.variants.find((variant) => sizeNumber(variant.eu) === eu);
  const selectedEu = () => {
    const paidSelect = details.querySelector('.kaching-bundles__collection-product .kaching-bundles__bar-variant-select');
    return sizeNumber(paidSelect?.value) ||
      sizeNumber(current.variants.find((variant) => String(variant.id) === String(data.selectedId))?.eu) ||
      sizeNumber(current.variants.find((variant) => variant.available)?.eu);
  };
  const colorName = (product) =>
    product.title.replace(/^.*?\s+-\s+/, '').trim() || product.title;
  const colorFromTitle = (title) => {
    const text = String(title || '').trim();
    const parts = text.split(/\s+-\s+/);
    return (parts.length > 1 ? parts[parts.length - 1] : text).trim();
  };
  const labelFor = (eu, system) => {
    if (system === 'EU') return eu;
    const variant = productSize(current, eu);
    return String(system === 'UK' ? variant?.uk || eu : variant?.usMen || eu);
  };
  const selectOption = (select, option) => {
    const setter = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;
    setter.call(select, option.value);
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
    requestAnimationFrame(refresh);
  };

  const normalizeText = (value) =>
    String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const familyKey = data.products
    .map((product) => String(product.id))
    .sort()
    .join('|');

  const GIFT_STORAGE_KEY = 'vkc_free_product_v1:' + familyKey;

  let restoringGift = false;
  let restoreTimeout = 0;
  let restoreCooldownUntil = 0;

  function readStoredGift() {
    try {
      const value = localStorage.getItem(GIFT_STORAGE_KEY);
      return value ? JSON.parse(value) : null;
    } catch (error) {
      return null;
    }
  }

  function writeStoredGift(row) {
    if (!row || restoringGift) return;

    const titleElement = row.querySelector('.kaching-bundles__collection-product__title');
    const title = titleElement?.textContent?.trim();
    if (!title) return;

    const product = data.products.find(
      (item) => normalizeText(item.title) === normalizeText(title)
    );

    const productLink = [...row.querySelectorAll('a[href]')].find((link) => {
      try {
        return new URL(link.href, location.origin).pathname.includes('/products/');
      } catch (error) {
        return false;
      }
    });

    let url = product?.url || '';
    if (productLink) {
      try {
        url = new URL(productLink.href, location.origin).pathname;
      } catch (error) {}
    }

    const sizeSelect = row.querySelector('.kaching-bundles__bar-variant-select');

    try {
      const nextValue = JSON.stringify({
        productId: product?.id || null,
        title,
        url,
        size: sizeSelect?.value || ''
      });
      if (localStorage.getItem(GIFT_STORAGE_KEY) !== nextValue) {
        localStorage.setItem(GIFT_STORAGE_KEY, nextValue);
      }
    } catch (error) {}
  }

  function clearStoredGift() {
    try {
      localStorage.removeItem(GIFT_STORAGE_KEY);
    } catch (error) {}

    restoringGift = false;
    document.documentElement.classList.remove('vkc-restoring-gift');
    restoreCooldownUntil = Date.now() + 1500;

    if (restoreTimeout) {
      clearTimeout(restoreTimeout);
      restoreTimeout = 0;
    }
  }

  function additionalProductRows() {
    return [...details.querySelectorAll(
      '.kaching-bundles__bar--selected .kaching-bundles__collection-product:not(:first-child)'
    )];
  }

  function isExplicitRemoveControl(target) {
    const control = target.closest('button, a, [role="button"]');
    if (!control) return false;

    const row = control.closest(
      '.kaching-bundles__bar--selected .kaching-bundles__collection-product:not(:first-child)'
    );
    if (!row) return false;

    const textValue = String(control.textContent || '').trim();
    const signature = [
      control.className,
      control.getAttribute('aria-label'),
      control.getAttribute('title'),
      textValue
    ].filter(Boolean).join(' ').toLowerCase();

    return /remove|delete|close|trash|clear/.test(signature) ||
      /^[x×✕✖]$/i.test(textValue);
  }

  function findRestoreAction(modal, state) {
    const wantedTitle = normalizeText(state?.title);

    const buttons = [...modal.querySelectorAll('button, [role="button"]')]
      .filter((button) =>
        !button.matches('.vkc-system, .vkc-size-option') &&
        !/close|dismiss|cancel/i.test(
          [
            button.className,
            button.getAttribute('aria-label'),
            button.getAttribute('title')
          ].filter(Boolean).join(' ')
        )
      );

    const actionWords = /choose|select|add|pick|free/i;

    for (const button of buttons) {
      let node = button;
      for (let depth = 0; node && node !== modal && depth < 6; depth += 1, node = node.parentElement) {
        const textValue = normalizeText(node.textContent);
        if (wantedTitle && textValue.includes(wantedTitle)) {
          const label = [
            button.textContent,
            button.getAttribute('aria-label'),
            button.getAttribute('title'),
            button.className
          ].filter(Boolean).join(' ');
          if (actionWords.test(label)) return button;
        }
      }
    }

    let matchingElement = null;

    if (state?.url) {
      const wantedPath = (() => {
        try {
          return new URL(state.url, location.origin).pathname;
        } catch (error) {
          return state.url;
        }
      })();

      matchingElement = [...modal.querySelectorAll('a[href]')].find((link) => {
        try {
          return new URL(link.href, location.origin).pathname === wantedPath;
        } catch (error) {
          return false;
        }
      }) || null;
    }

    if (!matchingElement && wantedTitle) {
      matchingElement = [...modal.querySelectorAll('*')].find((element) =>
        element.children.length === 0 &&
        normalizeText(element.textContent) === wantedTitle
      ) || null;
    }

    if (!matchingElement) return null;

    let node = matchingElement;
    for (let depth = 0; node && node !== modal && depth < 6; depth += 1, node = node.parentElement) {
      const action = [...node.querySelectorAll('button, [role="button"]')].find((button) => {
        if (button.matches('.vkc-system, .vkc-size-option')) return false;
        const label = [
          button.textContent,
          button.getAttribute('aria-label'),
          button.getAttribute('title'),
          button.className
        ].filter(Boolean).join(' ');
        return actionWords.test(label);
      });
      if (action) return action;
    }

    return matchingElement.matches('button, [role="button"]')
      ? matchingElement
      : matchingElement.closest('button, [role="button"]');
  }

  function closeRestoreModal(modal) {
    const close = [...modal.querySelectorAll('button, [role="button"]')].find((button) => {
      const label = [
        button.textContent,
        button.getAttribute('aria-label'),
        button.getAttribute('title'),
        button.className
      ].filter(Boolean).join(' ');
      return /close|dismiss|cancel/i.test(label) || /^[x×✕✖]$/i.test(String(button.textContent || '').trim());
    });
    close?.click();
  }

  function applyStoredSize(row, state) {
    if (!state?.size) return;

    const select = row.querySelector('.kaching-bundles__bar-variant-select');
    if (!select) return;

    const option = [...select.options].find((item) => item.value === state.size);
    if (option && select.value !== option.value) selectOption(select, option);
  }

  function waitForRestoredRow(state, attempt = 0) {
    const row = additionalProductRows()[0];

    if (row) {
      applyStoredSize(row, state);
      restoringGift = false;
      document.documentElement.classList.remove('vkc-restoring-gift');
      decorateAdditionalProduct(row);
      writeStoredGift(row);
      queueScan();
      return;
    }

    if (attempt >= 40) {
      restoringGift = false;
      document.documentElement.classList.remove('vkc-restoring-gift');
      restoreCooldownUntil = Date.now() + 5000;
      return;
    }

    setTimeout(() => waitForRestoredRow(state, attempt + 1), 100);
  }

  function waitForRestoreModal(state, attempt = 0) {
    const modal = document.querySelector('.kaching-bundles__choose-product-modal');

    if (modal) {
      const action = findRestoreAction(modal, state);

      if (action) {
        action.click();
        waitForRestoredRow(state);
        return;
      }

      if (attempt >= 30) {
        closeRestoreModal(modal);
        restoringGift = false;
        restoreCooldownUntil = Date.now() + 5000;
        return;
      }
    } else if (attempt >= 30) {
      restoringGift = false;
      restoreCooldownUntil = Date.now() + 5000;
      return;
    }

    setTimeout(() => waitForRestoreModal(state, attempt + 1), 100);
  }

  function restoreStoredGift() {
    const state = readStoredGift();
    if (!state || additionalProductRows().length || restoringGift) return;
    if (Date.now() < restoreCooldownUntil) return;

    const chooseButton = details.querySelector(
      '.kaching-bundles__collection-product__choose-product-button'
    );

    if (!chooseButton) return;

    restoringGift = true;
    document.documentElement.classList.add('vkc-restoring-gift');
    chooseButton.click();
    waitForRestoreModal(state);
  }

  function scheduleStoredGiftRestore() {
    if (restoringGift || restoreTimeout || Date.now() < restoreCooldownUntil) return;
    if (!readStoredGift() || additionalProductRows().length) return;

    restoreTimeout = setTimeout(() => {
      restoreTimeout = 0;
      restoreStoredGift();
    }, 120);
  }

  function buildColors(row) {
    if (row.querySelector('.vkc-colors')) return;
    const rail = document.createElement('div');
    rail.className = 'vkc-colors';
    rail.innerHTML = '<div class="vkc-heading vkc-color-heading">Color: <span class="vkc-color-name"></span></div><div class="vkc-color-list"></div>';
    const list = rail.querySelector('.vkc-color-list');
    const colorLabel = rail.querySelector('.vkc-color-name');
    if (colorLabel) colorLabel.textContent = colorName(current);
    for (const product of data.products) {
      const link = document.createElement('a');
      link.className = 'vkc-color';
      link.dataset.productId = product.id;
      link.title = colorName(product);
      link.setAttribute('aria-label', colorName(product));
      if (product.image) {
        const image = document.createElement('img');
        image.src = product.image;
        image.alt = '';
        image.loading = 'lazy';
        image.width = 39;
        image.height = 39;
        link.append(image);
      } else {
        link.textContent = colorName(product).slice(0, 2);
      }
      list.append(link);
    }
    const content = row.querySelector('.kaching-bundles__collection-product__content') || row;
    content.insertBefore(rail, content.querySelector('.kaching-bundles__bar-variant-names') || content.firstChild);
  }

  function buildSizes(select) {
    if (select.dataset.vkcReady) return;
    const options = [...select.options].map((option) => ({ option, eu: sizeNumber(option.value) || sizeNumber(option.textContent) }))
      .filter((entry) => entry.eu);
    if (options.length < 4) return;
    const rail = document.createElement('div');
    rail.className = 'vkc-size';
    rail.innerHTML = '<div class="vkc-size-head"><span class="vkc-heading">Size</span><div class="vkc-systems" role="group" aria-label="Size system"></div></div><div class="vkc-size-list" role="group" aria-label="Choose size"></div>';
    const systems = rail.querySelector('.vkc-systems');
    for (const system of ['EU', 'US', 'UK']) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'vkc-system';
      button.textContent = system;
      button.dataset.system = system;
      systems.append(button);
    }
    const list = rail.querySelector('.vkc-size-list');
    for (const { option, eu } of options) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'vkc-size-option';
      button.dataset.value = option.value;
      button.dataset.eu = eu;
      button.disabled = option.disabled;
      list.append(button);
    }
    select.closest('.kaching-bundles__bar-variant-selects')?.insertAdjacentElement('afterend', rail);
    select.dataset.vkcReady = 'true';
    const nativeGroup = select.closest('.kaching-bundles__bar-variant');
    nativeGroup?.classList.add('vkc-enhanced');
    if (nativeGroup?.previousElementSibling?.matches('.kaching-bundles__bar-variant-names')) {
      nativeGroup.previousElementSibling.classList.add('vkc-hidden-label');
    }
    updateSizeRail(rail, select);
  }

  function decorateAdditionalProduct(row) {
    if (!row) return;

    const title = row.querySelector('.kaching-bundles__collection-product__title');
    const sizeRail = row.querySelector('.vkc-size');
    const sizeHead = sizeRail?.querySelector('.vkc-size-head');
    if (!title || !sizeRail || !sizeHead) return;

    const color = colorFromTitle(title.textContent);
    if (!color) return;

    title.classList.add('vkc-additional-product-title');

    let label = row.querySelector('.vkc-additional-color');
    if (!label) {
      label = document.createElement('div');
      label.className = 'vkc-heading vkc-color-heading vkc-additional-color';
      label.innerHTML = 'Color: <span class="vkc-additional-color-name"></span>';
    }

    if (label.parentElement !== sizeHead) sizeHead.append(label);

    const value = label.querySelector('.vkc-additional-color-name');
    if (value && value.textContent !== color) value.textContent = color;
  }

  function updateSizeRail(rail, select) {
    const system = rail.dataset.system || 'EU';
    for (const button of rail.querySelectorAll('.vkc-system')) {
      button.setAttribute('aria-pressed', String(button.dataset.system === system));
    }
    for (const button of rail.querySelectorAll('.vkc-size-option')) {
      const label = labelFor(button.dataset.eu, system);
      if (button.textContent !== label) button.textContent = label;
      button.setAttribute('aria-label', system + ' ' + button.textContent);
      button.setAttribute('aria-pressed', String(button.dataset.value === select.value));
    }
  }

  function refresh() {
    const eu = selectedEu();
    for (const label of details.querySelectorAll('.vkc-color-name')) {
      const value = colorName(current);
      if (label.textContent !== value) label.textContent = value;
    }
    for (const link of details.querySelectorAll('.vkc-color')) {
      const product = data.products.find((item) => String(item.id) === link.dataset.productId);
      const variant = productSize(product, eu);
      const active = String(product.id) === String(current.id);
      const href = new URL(product.url, location.origin);
      if (variant && variant.available) href.searchParams.set('variant', variant.id);
      link.href = href.pathname + href.search;
      link.classList.toggle('is-selected', active);
      link.classList.toggle('is-unavailable', !variant?.available);
      link.setAttribute('aria-current', active ? 'true' : 'false');
      link.setAttribute('aria-disabled', String(!variant?.available));
      link.tabIndex = variant?.available ? 0 : -1;
    }
    for (const rail of document.querySelectorAll('.vkc-size')) {
      const select = rail.previousElementSibling?.querySelector('select');
      if (select) updateSizeRail(rail, select);
    }
  }

  let queued = false;
  function scan() {
    queued = false;
    for (const row of details.querySelectorAll('.kaching-bundles__bar--selected .kaching-bundles__collection-product:first-child')) {
      if (data.products.length > 1) buildColors(row);
    }
    for (const select of details.querySelectorAll('.kaching-bundles__bar-variant-select')) buildSizes(select);
    const additionalRows = additionalProductRows();
    for (const row of additionalRows) {
      decorateAdditionalProduct(row);
      writeStoredGift(row);
    }
    if (!additionalRows.length) scheduleStoredGiftRestore();
    for (const select of document.querySelectorAll('.kaching-bundles__choose-product-modal .kaching-bundles__bar-variant-select')) buildSizes(select);
    for (const price of details.querySelectorAll('.kaching-bundles__free-gift__full-price')) {
      if (price.textContent.trim() !== 'FREE') price.textContent = 'FREE';
      price.classList.add('vkc-free-badge');
    }
    const paidReady = !!details.querySelector('.kaching-bundles__collection-product:first-child .kaching-bundles__bar-variant-select[data-vkc-ready="true"]');
    details.classList.toggle('vkc-active', paidReady);
    for (const option of details.querySelectorAll('variant-picker .variant-option')) {
      const select = option.querySelector('select[name^="options["]');
      const name = select?.name.slice(8, -1).toLowerCase();
      option.classList.toggle('vkc-native-size-hidden', ['size', 'tamanho', 'taille', 'talla', 'größe'].includes(name));
    }
    refresh();
  }
  function queueScan() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(scan);
  }
  window.addEventListener('click', (event) => {
    if (isExplicitRemoveControl(event.target)) {
      clearStoredGift();
    }

    const system = event.target.closest('.vkc-system');
    if (system) {
      event.preventDefault();
      event.stopPropagation();
      const rail = system.closest('.vkc-size');
      rail.dataset.system = system.dataset.system;
      refresh();
      return;
    }
    const option = event.target.closest('.vkc-size-option');
    if (option && !option.disabled) {
      event.preventDefault();
      event.stopPropagation();
      const select = option.closest('.vkc-size').previousElementSibling?.querySelector('select');
      const nativeOption = [...(select?.options || [])].find((item) => item.value === option.dataset.value);
      if (select && nativeOption) selectOption(select, nativeOption);
      return;
    }
    const color = event.target.closest('.vkc-color');
    if (color?.getAttribute('aria-disabled') === 'true') event.preventDefault();
    if (event.target.closest('.kaching-bundles__collection-product__choose-product-button')) {
      const observer = new MutationObserver(queueScan);
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 4000);
      queueScan();
    }
  }, true);
  details.addEventListener('change', (event) => {
    if (!event.target.matches('.kaching-bundles__bar-variant-select')) return;

    const row = event.target.closest(
      '.kaching-bundles__bar--selected .kaching-bundles__collection-product:not(:first-child)'
    );

    if (row) requestAnimationFrame(() => writeStoredGift(row));
    requestAnimationFrame(refresh);
  });
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.target instanceof Element && mutation.target.closest('.kaching-bundles, variant-picker')) {
        queueScan();
        return;
      }
      for (const node of [...mutation.addedNodes, ...mutation.removedNodes]) {
        if (node instanceof Element &&
            (node.matches('.kaching-bundles, variant-picker') || node.querySelector('.kaching-bundles, variant-picker'))) {
          queueScan();
          return;
        }
      }
    }
  }).observe(details, { childList: true, subtree: true });
  scan();
})();

